<script>
  import { createEventDispatcher } from 'svelte';

  import { Spinner } from '@client/components/spinner';

  const dispatch = createEventDispatcher();

  export let isUpdating = false;
  export let source = '';

  const DEBOUNCE_DELAY = 200;

  let bizcardIframe = null;
  let debouncedSource = '';
  let debounceTimer = null;
  let blur = false;

  const hideScrollbar = (e) => {
    blur = true;

    if (!bizcardIframe) {
      return;
    }

    const doc = bizcardIframe.contentDocument;
    const html = doc?.documentElement;

    if (html) {
      html.style.overflow = 'scroll';
      html.style.scrollbarWidth = 'none';
    }

    dispatch('load', e);

    blur = false;
  };

  $: if (source !== debouncedSource) {
    blur = true;

    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(() => {
      debouncedSource = source;
      blur = false;
    }, DEBOUNCE_DELAY);
  }
</script>

<Spinner bind:show={isUpdating} backdrop />

<iframe
  bind:this={bizcardIframe}
  class="bizcard-preview-iframe"
  class:blur
  tabindex="-1"
  title="preview"
  srcdoc={debouncedSource}
  on:load={hideScrollbar}
/>

<style lang="scss" src="./card-preview.scss"></style>
